import {
  ActivateAccountRequestDTO,
  ActivateAccountResponseDTO,
  AddUsersRequestDTO,
  BulkImportAssetsRequestDTO,
  BulkImportAssetsResponseDTO,
  BulkImportLocationsRequestDTO,
  BulkImportLocationsResponseDTO,
  BulkUpdateDocumentStateRequestDTO,
  BulkUpdateScheduleStateRequestDTO,
  BulkUpdateStateAssetsRequestDTO,
  BulkUpdateStateFormsRequestDTO,
  BulkUpdateStateIssuesRequestDTO,
  BulkUpdateStateLocationsRequestDTO,
  BulkUpdateStateWorkOrdersRequestDTO,
  BulkUpdateStatusWorkOrdersRequestDTO,
  BulkUpdateTagsWorkOrdersRequestDTO,
  CheckPhoneOnSignupRequestDTO,
  CheckPhoneOnSignupResponseDTO,
  CloneFormResponseDTO,
  CloneFormsRequestDTO,
  CloneFormsResponseDTO,
  CloneScheduleResponseDTO,
  CreateAssetDocumentRequestDTO,
  CreateAssetDocumentResponseDTO,
  CreateAssetLocationRequestDTO,
  CreateAssetLocationResponseDTO,
  CreateAssetRequestDTO,
  CreateAssetResponseDTO,
  CreateBulkPdfExportRequestDTO,
  CreateBulkPdfExportResponseDTO,
  CreateCsvExportRequestDTO,
  CreateCsvExportResponseDTO,
  CreateDeploymentRuleRequestDTO,
  CreateDeploymentRuleResponseDTO,
  CreateFormRequestDTO,
  CreateFormResponseDTO,
  CreateIssueRequestDTO,
  CreateIssueResponseDTO,
  CreateListRequestDTO,
  CreateListResponseDTO,
  CreateLocationRequestDTO,
  CreateLocationResponseDTO,
  CreatePdfExportRequestDTO,
  CreatePdfExportResponseDTO,
  CreateRegisterPdfExportRequestDTO,
  CreateRegisterPdfExportResponseDTO,
  CreateRepairRequestDTO,
  CreateRepairResponseDTO,
  CreateScheduleFormRequestDTO,
  CreateScheduleFormResponseDTO,
  CreateScheduleNotificationRuleRequestDTO,
  CreateScheduleNotificationRuleResponseDTO,
  CreateScheduleRequestDTO,
  CreateScheduleResponseDTO,
  CreateUnitReadingRequestDTO,
  CreateUnitReadingResponseDTO,
  CreateWorkOrderRequestDTO,
  CreateWorkOrderResponseDTO,
  CreateWorkspaceAssetCategoryRequestDTO,
  CreateWorkspaceAssetCategoryResponseDTO,
  CreateWorkspaceRequestDTO,
  CreateWorkspaceResponseDTO,
  DeleteDeploymentRulesRequestDTO,
  DeleteInspectionsRequestDTO,
  DeleteInspectionsResponseDTO,
  DeleteIssueNotificationRuleRequestDTO,
  DeleteListsRequestDTO,
  DeleteRepairsRequestDTO,
  DeleteRepairsResponseDTO,
  DeleteScheduleNotificationRuleRequestDTO,
  DeleteUsersRequestDTO,
  DeleteUsersResponseDTO,
  GenerateAssetPhotoPresignedUploadUrlRequestDTO,
  GenerateAssetPhotoPresignedUploadUrlResponseDTO,
  GenerateDocumentPresignedUploadUrlRequestDTO,
  GenerateDocumentPresignedUploadUrlResponseDTO,
  GenerateIssueFilePresignedUploadUrlRequestDTO,
  GenerateIssueFilePresignedUploadUrlResponseDTO,
  GeneratePdfAttachmentFormFieldPresignedUploadUrlRequestDTO,
  GeneratePdfAttachmentFormFieldPresignedUploadUrlResponseDTO,
  GetActionsRequestDTO,
  GetActionsResponseDTO,
  GetAddressRequestDTO,
  GetAddressResponseDTO,
  GetAssetByIdResponseDTO,
  GetAssetCategoriesRequestDTO,
  GetAssetCategoriesResponseDTO,
  GetAssetFormsByTypeRequestDTO,
  GetAssetFormsByTypeResponseDTO,
  GetAssetLocationsRequestDTO,
  GetAssetLocationsResponseDTO,
  GetAssetsRequestDTO,
  GetAssetsResponseDTO,
  GetCategoriesRequestDTO,
  GetCategoriesResponseDTO,
  GetCheckRequestDTO,
  GetCheckResponseDTO,
  GetChecksByAssetRequestDTO,
  GetChecksByAssetResponseDTO,
  GetChecksRequestDTO,
  GetChecksResponseDTO,
  GetContactsRequestDTO,
  GetContactsResponseDTO,
  GetCurrentWebUserResponseDTO,
  GetDashboardFormSubmissionsResponseDTO,
  GetDashboardInspectionsTodayResponseDTO,
  GetDashboardInspectionTrendResponseDTO,
  GetDashboardIssuesByAssetResponseDTO,
  GetDashboardIssuesSummaryResponseDTO,
  GetDashboardOnboardingResponseDTO,
  GetDashboardRecentIssuesResponseDTO,
  GetDeploymentRecalcRunResponseDTO,
  GetDeploymentRuleByIdResponseDTO,
  GetDeploymentRulesRequestDTO,
  GetDeploymentRulesResponseDTO,
  GetDocumentsByAssetRequestDTO,
  GetDocumentsByAssetResponseDTO,
  GetDocumentsRequestDTO,
  GetDocumentsResponseDTO,
  GetExportRunResponseDTO,
  GetFormByIdResponseDTO,
  GetFormRevisionByIdRequestDTO,
  GetFormRevisionByIdResponseDTO,
  GetFormRevisionsResponseDTO,
  GetFormsRequestDTO,
  GetFormsResponseDTO,
  GetFormSubmissionRevisionsResponseDTO,
  GetInspectionByIdRequestDTO,
  GetInspectionByIdResponseDTO,
  GetInspectionFormsRequestDTO,
  GetInspectionFormsResponseDTO,
  GetInspectionRevisionsRequestDTO,
  GetInspectionsRequestDTO,
  GetInspectionsResponseDTO,
  GetIssueByIdResponseDTO,
  GetIssueChecksByAssetRequestDTO,
  GetIssueChecksByAssetResponseDTO,
  GetIssueNotificationRulesResponseDTO,
  GetIssuesByAssetRequestDTO,
  GetIssuesByAssetResponseDTO,
  GetIssuesRequestDTO,
  GetIssuesResponseDTO,
  GetListByIdResponseDTO,
  GetListsRequestDTO,
  GetListsResponseDTO,
  GetLocationByIdRequestDTO,
  GetLocationByIdResponseDTO,
  GetLocationsRequestDTO,
  GetLocationsResponseDTO,
  GetManufacturersRequestDTO,
  GetManufacturersResponseDTO,
  GetNotificationRulesRequestDTO,
  GetNotificationRulesResponseDTO,
  GetNotificationsResponseDTO,
  GetNotifyWorkOrderResponseDTO,
  GetPdfExportResponseDTO,
  GetQRCodesRequestDTO,
  GetQRCodesResponseDTO,
  GetRepairByIdRequestDTO,
  GetRepairByIdResponseDTO,
  GetRepairFormsRequestDTO,
  GetRepairFormsResponseDTO,
  GetRepairRevisionsRequestDTO,
  GetRepairsRequestDTO,
  GetRepairsResponseDTO,
  GetScheduleByIdRequestDTO,
  GetScheduleByIdResponseDTO,
  GetScheduleFormByIdRequestDTO,
  GetScheduleFormByIdResponseDTO,
  GetScheduleFormFormsRequestDTO,
  GetScheduleFormFormsResponseDTO,
  GetScheduleFormRevisionsRequestDTO,
  GetScheduleFormsRequestDTO,
  GetScheduleFormsResponseDTO,
  GetScheduleNotificationRuleByIdResponseDTO,
  GetScheduleNotificationRulesRequestDTO,
  GetScheduleNotificationRulesResponseDTO,
  GetSchedulesRequestDTO,
  GetSchedulesResponseDTO,
  GetSitemateUserResponseDTO,
  GetTagsRequestDTO,
  GetTagsResponseDTO,
  GetUnitReadingsRequestDTO,
  GetUnitReadingsResponseDTO,
  GetUnitsRequestDTO,
  GetUnitsResponseDTO,
  GetUpcomingChecksSummaryResponseDTO,
  GetUserByActivationIdRequestDTO,
  GetUserByActivationIdResponseDTO,
  GetUsersRequestDTO,
  GetUsersResponseDTO,
  GetUsersStatsRequestDTO,
  GetUsersStatsResponseDTO,
  GetWorkOrderByIdRequestDTO,
  GetWorkOrderByIdResponseDTO,
  GetWorkOrdersRequestDTO,
  GetWorkOrdersResponseDTO,
  GetWorkspaceBrandingRequestDTO,
  GetWorkspaceBrandingResponseDTO,
  GetWorkspaceByIdRequestDTO,
  GetWorkspaceByIdResponseDTO,
  GetWorkspacePageConfigByHandleRequestDTO,
  GetWorkspacePageConfigByHandleResponseDTO,
  OnboardInvitedMemberRequestDTO,
  OnboardInvitedMemberResponseDTO,
  ReinviteUserRequestDTO,
  SearchAddressesRequestDTO,
  SearchAddressesResponseDTO,
  SendInspectionLinkToMobileRequestDTO,
  SignupRequestDTO,
  SignupResponseDTO,
  UpdateAssetMaintenanceRequestDTO,
  UpdateAssetMaintenanceResponseDTO,
  UpdateAssetPhotoRequestDTO,
  UpdateAssetPhotoResponseDTO,
  UpdateAssetRequestDTO,
  UpdateAssetResponseDTO,
  UpdateAssetsRequestDTO,
  UpdateAutoCloseChecksOnScheduleFormSubmitRequestDTO,
  UpdateAutoCloseChecksOnScheduleFormSubmitResponseDTO,
  UpdateAutoCloseIssuesOnRepairSubmitRequestDTO,
  UpdateAutoCloseIssuesOnRepairSubmitResponseDTO,
  UpdateCategoriesRequestDTO,
  UpdateCategoriesResponseDTO,
  UpdateCheckRequestDTO,
  UpdateChecksRequestDTO,
  UpdateDeploymentRuleRequestDTO,
  UpdateDeploymentRuleResponseDTO,
  UpdateDocumentRequestDTO,
  UpdateDocumentResponseDTO,
  UpdateFormRequestDTO,
  UpdateFormResponseDTO,
  UpdateInspectionRequestDTO,
  UpdateInspectionResponseDTO,
  UpdateIssueRequestDTO,
  UpdateIssueResponseDTO,
  UpdateIssuesRequestDTO,
  UpdateListRequestDTO,
  UpdateListResponseDTO,
  UpdateLocationRequestDTO,
  UpdateLocationResponseDTO,
  UpdateMcpAccessLevelRequestDTO,
  UpdateMcpAccessLevelResponseDTO,
  UpdateNotificationRuleItemDTO,
  UpdateNotificationRulesRequestDTO,
  UpdateNotificationRulesResponseDTO,
  UpdateNotificationsRequestDTO,
  UpdateNotificationsResponseDTO,
  UpdateNotifyInspectionRequestDTO,
  UpdateNotifyInspectionResponseDTO,
  UpdateNotifyWorkOrderRequestDTO,
  UpdateNotifyWorkOrderResponseDTO,
  UpdateRepairRequestDTO,
  UpdateRepairResponseDTO,
  UpdateScheduleFormRequestDTO,
  UpdateScheduleFormResponseDTO,
  UpdateScheduleNotificationRuleRequestDTO,
  UpdateScheduleNotificationRuleResponseDTO,
  UpdateScheduleRequestDTO,
  UpdateScheduleResponseDTO,
  UpdateTagsRequestDTO,
  UpdateTagsResponseDTO,
  UpdateUserProfileRequestDTO,
  UpdateUserProfileResponseDTO,
  UpdateUserRoleRequestDTO,
  UpdateWorkOrderRequestDTO,
  UpdateWorkOrderResponseDTO,
  UpdateWorkspaceBrandingRequestDTO,
  UpdateWorkspaceBrandingResponseDTO,
  UpdateWorkspaceFeatureAccessRequestDTO,
  UpdateWorkspacePageConfigRequestDTO,
  UpdateWorkspacePageConfigResponseDTO,
  UpdateWorkspaceRequestDTO,
  UpdateWorkspaceResponseDTO,
  UpsertIssueNotificationRuleRequestDTO,
  UpsertIssueNotificationRuleResponseDTO,
  UpsertUnitsRequestDTO,
  UpsertUnitsResponseDTO,
  ValidateUniqueUserEmailRequestDTO,
} from '@gearbelt/global';
import ky from 'ky';
import qs from 'qs';

import { env } from '@/env';
import { userManager } from '@/lib/fusionauth';
import { handleAuthResponse } from '@/services/handle-auth-response';
import { useUserStore } from '@/stores/user.store';

export abstract class ApiService {
  static client = ky.create({
    prefixUrl: `${env.VITE_API_URL}/api/v2/`,
    headers: {
      'Content-Type': 'application/json',
      'x-client-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    timeout: 20000,
    retry: 0,
    hooks: {
      beforeRequest: [
        async (request) => {
          const userStore = useUserStore.getState();
          if (userStore.org) {
            request.headers.set('x-workspace-id', userStore.org.id);
          }

          const user = await userManager.getUser();
          if (user && user.access_token) {
            request.headers.set('Authorization', `JWT ${user.access_token}`);
            request.headers.set('authtype', 'fusionauth');
          }
        },
      ],
      afterResponse: [async (request, _options, response) => handleAuthResponse(request, response)],
    },
  });

  static async GetAssets(dto: GetAssetsRequestDTO) {
    return await this.client.get<GetAssetsResponseDTO>('assets', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetAssetById(assetId: string) {
    return await this.client.get<GetAssetByIdResponseDTO>(`assets/${assetId}`);
  }

  static async UpdateAssets(dto: UpdateAssetsRequestDTO) {
    return await this.client.put<undefined>(`assets/bulk-update`, {
      json: dto,
    });
  }

  static async GetAssetCategories(dto: GetAssetCategoriesRequestDTO) {
    return await this.client.get<GetAssetCategoriesResponseDTO>('asset-categories', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateWorkspaceAssetCategory(dto: CreateWorkspaceAssetCategoryRequestDTO) {
    return await this.client.post<CreateWorkspaceAssetCategoryResponseDTO>('asset-categories', {
      json: dto,
    });
  }

  static async CreateAsset(dto: CreateAssetRequestDTO) {
    return await this.client.post<CreateAssetResponseDTO>('assets', {
      json: dto,
    });
  }

  static async BulkImportAssets(dto: BulkImportAssetsRequestDTO) {
    return await this.client.post<BulkImportAssetsResponseDTO>('assets/bulk-import', {
      json: dto,
    });
  }

  static async UpdateAsset(assetId: string, dto: Omit<UpdateAssetRequestDTO, 'assetId'>) {
    return await this.client.patch<UpdateAssetResponseDTO>(`assets/${assetId}`, {
      json: dto,
    });
  }

  static async BulkUpdateAssetState(dto: BulkUpdateStateAssetsRequestDTO) {
    return await this.client.patch<undefined>('assets/bulk-update-state', {
      json: dto,
    });
  }

  static async GetLocations(dto: GetLocationsRequestDTO) {
    return await this.client.get<GetLocationsResponseDTO>('locations', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateLocation(dto: CreateLocationRequestDTO) {
    return await this.client.post<CreateLocationResponseDTO>('locations', {
      json: dto,
    });
  }

  static async GetLocationById(dto: GetLocationByIdRequestDTO) {
    return await this.client.get<GetLocationByIdResponseDTO>(`locations/${dto.locationId}`);
  }

  static async UpdateLocation(locationId: string, dto: UpdateLocationRequestDTO) {
    return await this.client.put<UpdateLocationResponseDTO>(`locations/${locationId}`, {
      json: dto,
    });
  }

  static async BulkUpdateLocationState(dto: BulkUpdateStateLocationsRequestDTO) {
    return await this.client.patch<undefined>('locations/bulk-update-state', {
      json: dto,
    });
  }

  static async BulkImportLocations(dto: BulkImportLocationsRequestDTO) {
    return await this.client.post<BulkImportLocationsResponseDTO>('locations/bulk-import', {
      json: dto,
    });
  }

  static async GetLists(dto: GetListsRequestDTO) {
    return await this.client.get<GetListsResponseDTO>('lists', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async DeleteLists(dto: DeleteListsRequestDTO) {
    return await this.client.post<undefined>('lists/bulk-delete', {
      json: dto,
    });
  }

  static async CreateList(dto: CreateListRequestDTO) {
    return await this.client.post<CreateListResponseDTO>('lists', {
      json: dto,
    });
  }

  static async UpdateList(listId: string, dto: UpdateListRequestDTO) {
    return await this.client.put<UpdateListResponseDTO>(`lists/${listId}`, {
      json: dto,
    });
  }

  static async GetWorkspaceById(dto: GetWorkspaceByIdRequestDTO) {
    const { workspaceId } = dto;
    return await this.client.get<GetWorkspaceByIdResponseDTO>(`workspaces/${workspaceId}`);
  }

  static async UpdateWorkspaceFeatureAccess(dto: UpdateWorkspaceFeatureAccessRequestDTO) {
    const { workspaceId, ...featureAccessDTO } = dto;
    return await this.client.patch<void>(`workspaces/${workspaceId}/feature-access`, {
      json: featureAccessDTO,
    });
  }

  static async GetWorkspaceBranding(dto: GetWorkspaceBrandingRequestDTO) {
    const { workspaceId } = dto;
    return await this.client.get<GetWorkspaceBrandingResponseDTO>(`workspaces/${workspaceId}/branding`);
  }

  static async UpdateWorkspaceBranding(dto: UpdateWorkspaceBrandingRequestDTO) {
    const { workspaceId, ...body } = dto;
    return await this.client.patch<UpdateWorkspaceBrandingResponseDTO>(`workspaces/${workspaceId}/branding`, {
      json: body,
    });
  }

  static async UpdateAutoCloseIssuesOnRepairSubmit(dto: UpdateAutoCloseIssuesOnRepairSubmitRequestDTO) {
    const { workspaceId, ...body } = dto;
    return await this.client.patch<UpdateAutoCloseIssuesOnRepairSubmitResponseDTO>(`workspaces/${workspaceId}/auto-close-issues-on-repair-submit`, {
      json: body,
    });
  }

  static async UpdateAutoCloseChecksOnScheduleFormSubmit(dto: UpdateAutoCloseChecksOnScheduleFormSubmitRequestDTO) {
    const { workspaceId, ...body } = dto;
    return await this.client.patch<UpdateAutoCloseChecksOnScheduleFormSubmitResponseDTO>(
      `workspaces/${workspaceId}/auto-close-checks-on-schedule-form-submit`,
      { json: body },
    );
  }

  static async UpdateMcpAccessLevel(dto: UpdateMcpAccessLevelRequestDTO) {
    const { workspaceId, ...body } = dto;
    return await this.client.patch<UpdateMcpAccessLevelResponseDTO>(`workspaces/${workspaceId}/mcp-access-level`, {
      json: body,
    });
  }

  static async GetWorkspacePageConfigByHandle(dto: GetWorkspacePageConfigByHandleRequestDTO) {
    const { workspaceId, handle } = dto;
    return await this.client.get<GetWorkspacePageConfigByHandleResponseDTO>(`workspaces/${workspaceId}/page-config/${handle}`);
  }

  static async UpdateWorkspacePageConfig(dto: UpdateWorkspacePageConfigRequestDTO) {
    const { workspaceId, ...body } = dto;
    return await this.client.patch<UpdateWorkspacePageConfigResponseDTO>(`workspaces/${workspaceId}/page-config`, {
      json: body,
    });
  }

  static async CreateWorkspace(dto: CreateWorkspaceRequestDTO) {
    return await this.client.post<CreateWorkspaceResponseDTO>('workspaces', {
      json: dto,
    });
  }

  static async UpdateWorkspace(dto: UpdateWorkspaceRequestDTO) {
    const { workspaceId, ...body } = dto;
    return await this.client.patch<UpdateWorkspaceResponseDTO>(`workspaces/${workspaceId}`, {
      json: body,
    });
  }

  static async CheckPhoneOnSignup(dto: CheckPhoneOnSignupRequestDTO): Promise<CheckPhoneOnSignupResponseDTO> {
    return this.client.post<CheckPhoneOnSignupResponseDTO>('auth/signup/check-phone', { json: dto }).json();
  }

  static async SignUp(dto: SignupRequestDTO) {
    return await this.client.post<SignupResponseDTO>('auth/signup', {
      json: dto,
    });
  }

  static async ValidateUniqueUserEmail(dto: ValidateUniqueUserEmailRequestDTO) {
    return await this.client.post('auth/signup/validate-email', {
      json: dto,
    });
  }

  static async VerifyActivationId(dto: GetUserByActivationIdRequestDTO) {
    const { activationId } = dto;
    return await this.client.get<GetUserByActivationIdResponseDTO>(`auth/activation/${activationId}`);
  }

  static async ActivateAccount(dto: ActivateAccountRequestDTO) {
    const { activationId, ...body } = dto;
    return await this.client.put<ActivateAccountResponseDTO>(`auth/activation/${activationId}`, {
      json: body,
    });
  }

  static async OnboardInvitedMember(dto: OnboardInvitedMemberRequestDTO) {
    const { activationId, ...body } = dto;
    return await this.client.put<OnboardInvitedMemberResponseDTO>(`auth/onboard/${activationId}`, {
      json: body,
    });
  }

  static async GetIssuesByAsset(dto: GetIssuesByAssetRequestDTO) {
    return await this.client.get<GetIssuesByAssetResponseDTO>(`issues/assets/${dto.assetId}`, {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetListById(listId: string) {
    return await this.client.get<GetListByIdResponseDTO>(`lists/${listId}`);
  }

  static async CreateForm(dto: CreateFormRequestDTO) {
    return await this.client.post<CreateFormResponseDTO>('forms', {
      json: dto,
    });
  }

  static async GetFormById(formId: string) {
    return await this.client.get<GetFormByIdResponseDTO>(`forms/${formId}`);
  }

  static async UpdateForm(formId: string, dto: UpdateFormRequestDTO) {
    return await this.client.patch<UpdateFormResponseDTO>(`forms/${formId}`, {
      json: dto,
    });
  }

  static async GetAssetFormsByType({ assetId, type }: GetAssetFormsByTypeRequestDTO) {
    return await this.client.get<GetAssetFormsByTypeResponseDTO>(`asset-forms/assets/${assetId}/type/${type}`);
  }

  static async CloneForm(formId: string) {
    return await this.client.post<CloneFormResponseDTO>(`forms/${formId}/clone`);
  }

  static async CloneForms(dto: CloneFormsRequestDTO) {
    return await this.client.post<CloneFormsResponseDTO>('forms/bulk-clone', {
      json: dto,
    });
  }

  static async GetInspectionForms(dto: GetInspectionFormsRequestDTO) {
    return await this.client.get<GetInspectionFormsResponseDTO>('inspections/forms', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async BulkUpdateFormState(dto: BulkUpdateStateFormsRequestDTO) {
    return await this.client.patch<void>('forms/bulk-update-state', {
      json: dto,
    });
  }

  static async GetIssueChecksByAsset(dto: GetIssueChecksByAssetRequestDTO) {
    return await this.client.get<GetIssueChecksByAssetResponseDTO>(`issues/assets/${dto.assetId}/checks`);
  }

  static async GetCheckById(dto: GetCheckRequestDTO) {
    return await this.client.get<GetCheckResponseDTO>(`checks/${dto.checkId}`);
  }

  static async UpdateCheck(dto: UpdateCheckRequestDTO) {
    const { checkId, ...body } = dto;
    return await this.client.patch(`checks/${checkId}`, {
      json: body,
    });
  }

  static async UpdateChecks(dto: UpdateChecksRequestDTO) {
    return await this.client.put<undefined>(`checks/bulk-update`, {
      json: dto,
    });
  }

  static async GetChecksByAsset(dto: GetChecksByAssetRequestDTO) {
    return await this.client.get<GetChecksByAssetResponseDTO>(`checks/assets/${dto.assetId}`);
  }

  static async GetChecks(dto: GetChecksRequestDTO) {
    return await this.client.get<GetChecksResponseDTO>('checks', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetContacts(dto: GetContactsRequestDTO) {
    return await this.client.get<GetContactsResponseDTO>('contacts', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetInspections(dto: GetInspectionsRequestDTO) {
    return await this.client.get<GetInspectionsResponseDTO>('inspections', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async DeleteInspections(dto: DeleteInspectionsRequestDTO) {
    return await this.client.post<DeleteInspectionsResponseDTO>('inspections/bulk-delete', {
      json: dto,
    });
  }

  static async SendInspectionLinkToMobile(dto: SendInspectionLinkToMobileRequestDTO) {
    return await this.client.post<void>('inspections/send-link-mobile', {
      json: dto,
    });
  }

  static async GetFormRevisionById(dto: GetFormRevisionByIdRequestDTO) {
    return await this.client.get<GetFormRevisionByIdResponseDTO>(`forms/revisions/${dto.formRevisionId}`);
  }

  static async GetFormRevisions(formId: string) {
    return await this.client.get<GetFormRevisionsResponseDTO>(`forms/${formId}/revisions`);
  }

  static async GetInspectionById(dto: GetInspectionByIdRequestDTO) {
    return await this.client.get<GetInspectionByIdResponseDTO>(`inspections/${dto.inspectionId}`);
  }

  static async GetInspectionRevisions(dto: GetInspectionRevisionsRequestDTO) {
    return await this.client.get<GetFormSubmissionRevisionsResponseDTO>(`inspections/${dto.inspectionId}/revisions`);
  }

  static async GetRepairRevisions(dto: GetRepairRevisionsRequestDTO) {
    return await this.client.get<GetFormSubmissionRevisionsResponseDTO>(`repairs/${dto.repairId}/revisions`);
  }

  static async GetScheduleFormRevisions(dto: GetScheduleFormRevisionsRequestDTO) {
    return await this.client.get<GetFormSubmissionRevisionsResponseDTO>(`schedule-forms/${dto.scheduleFormId}/revisions`);
  }

  static async GetScheduleFormById(dto: GetScheduleFormByIdRequestDTO) {
    return await this.client.get<GetScheduleFormByIdResponseDTO>(`schedule-forms/${dto.scheduleFormId}`);
  }

  static async CreateRepair(dto: CreateRepairRequestDTO) {
    return await this.client.post<CreateRepairResponseDTO>('repairs', {
      json: dto,
    });
  }

  static async UpdateInspection(inspectionId: string, dto: UpdateInspectionRequestDTO) {
    return await this.client.patch<UpdateInspectionResponseDTO>(`inspections/${inspectionId}`, {
      json: dto,
    });
  }

  static async UpdateRepair(repairId: string, dto: UpdateRepairRequestDTO) {
    return await this.client.patch<UpdateRepairResponseDTO>(`repairs/${repairId}`, {
      json: dto,
    });
  }

  static async UpdateScheduleForm(scheduleFormId: string, dto: UpdateScheduleFormRequestDTO) {
    return await this.client.patch<UpdateScheduleFormResponseDTO>(`schedule-forms/${scheduleFormId}`, {
      json: dto,
    });
  }

  static async DeleteRepairs(dto: DeleteRepairsRequestDTO) {
    return await this.client.post<DeleteRepairsResponseDTO>('repairs/bulk-delete', {
      json: dto,
    });
  }

  static async GetRepairById(dto: GetRepairByIdRequestDTO) {
    return await this.client.get<GetRepairByIdResponseDTO>(`repairs/${dto.repairId}`);
  }

  static async GetRepairs(dto: GetRepairsRequestDTO) {
    return await this.client.get<GetRepairsResponseDTO>('repairs', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateIssue(dto: CreateIssueRequestDTO) {
    return await this.client.post<CreateIssueResponseDTO>('issues', {
      json: dto,
    });
  }

  static async GetIssues(dto: GetIssuesRequestDTO) {
    return await this.client.get<GetIssuesResponseDTO>('issues', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async UpdateIssues(dto: UpdateIssuesRequestDTO) {
    return await this.client.put<undefined>(`issues/bulk-update`, {
      json: dto,
    });
  }

  static async BulkUpdateIssueState(dto: BulkUpdateStateIssuesRequestDTO) {
    return await this.client.patch<undefined>('issues/bulk-update-state', {
      json: dto,
    });
  }

  static async UpdateIssue(issueId: string, dto: UpdateIssueRequestDTO) {
    return await this.client.patch<UpdateIssueResponseDTO>(`issues/${issueId}`, {
      json: dto,
    });
  }

  static async UnlinkIssue(issueId: string) {
    return await this.client.patch<undefined>(`issues/${issueId}/unlink`);
  }

  static async UnlinkCheck(checkId: string) {
    return await this.client.patch<undefined>(`checks/${checkId}/unlink`);
  }

  static async GetRepairForms(dto: GetRepairFormsRequestDTO) {
    return await this.client.get<GetRepairFormsResponseDTO>('repairs/forms', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetScheduleForms(dto: GetScheduleFormsRequestDTO) {
    return await this.client.get<GetScheduleFormsResponseDTO>('schedule-forms', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateScheduleForm(dto: CreateScheduleFormRequestDTO) {
    return await this.client.post<CreateScheduleFormResponseDTO>('schedule-forms', {
      json: dto,
    });
  }

  static async DeleteScheduleForms(dto: {}) {
    return await this.client.post<{}>('schedule-forms/bulk-delete', {
      json: dto,
    });
  }

  // Schedules v2
  static async GetSchedules(dto: GetSchedulesRequestDTO) {
    return await this.client.get<GetSchedulesResponseDTO>('schedules', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetScheduleById(dto: GetScheduleByIdRequestDTO) {
    return await this.client.get<GetScheduleByIdResponseDTO>(`schedules/${dto.scheduleId}`);
  }

  static async CreateSchedule(dto: CreateScheduleRequestDTO) {
    return await this.client.post<CreateScheduleResponseDTO>('schedules', {
      json: dto,
    });
  }

  static async BulkUpdateScheduleState(dto: BulkUpdateScheduleStateRequestDTO) {
    return await this.client.post<void>('schedules/bulk-update-state', {
      json: dto,
    });
  }

  static async UpdateSchedule(dto: UpdateScheduleRequestDTO) {
    return await this.client.patch<UpdateScheduleResponseDTO>(`schedules/${dto.scheduleId}`, {
      json: dto,
    });
  }

  static async CloneSchedule(scheduleId: string) {
    return await this.client.post<CloneScheduleResponseDTO>(`schedules/${scheduleId}/clone`);
  }

  static async GetScheduleFormForms(dto: GetScheduleFormFormsRequestDTO) {
    return await this.client.get<GetScheduleFormFormsResponseDTO>('schedule-forms/forms', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetDeploymentRules(dto: GetDeploymentRulesRequestDTO) {
    return await this.client.get<GetDeploymentRulesResponseDTO>('deployment-rules', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetTags(dto: GetTagsRequestDTO) {
    return await this.client.get<GetTagsResponseDTO>('tags', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async UpdateTags(dto: UpdateTagsRequestDTO) {
    return await this.client.put<UpdateTagsResponseDTO>('tags', {
      json: dto,
    });
  }

  static async GetCategories(dto: GetCategoriesRequestDTO) {
    return await this.client.get<GetCategoriesResponseDTO>('categories', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async UpdateCategories(dto: UpdateCategoriesRequestDTO) {
    return await this.client.put<UpdateCategoriesResponseDTO>('categories', {
      json: dto,
    });
  }

  static async DeleteDeploymentRules(dto: DeleteDeploymentRulesRequestDTO) {
    return await this.client.post<undefined>('deployment-rules/bulk-delete', {
      json: dto,
    });
  }

  static async GetForms(dto: GetFormsRequestDTO) {
    return await this.client.get<GetFormsResponseDTO>('forms', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateDeploymentRule(dto: CreateDeploymentRuleRequestDTO) {
    return await this.client.post<CreateDeploymentRuleResponseDTO>('deployment-rules', {
      json: dto,
      timeout: 120000, // 2 minutes - deployment rule creation can be slow
    });
  }

  static async GetDeploymentRule(deploymentRuleId: string) {
    return await this.client.get<GetDeploymentRuleByIdResponseDTO>(`deployment-rules/${deploymentRuleId}`);
  }

  static async UpdateDeploymentRule(deploymentRuleId: string, dto: UpdateDeploymentRuleRequestDTO) {
    return await this.client.patch<UpdateDeploymentRuleResponseDTO>(`deployment-rules/${deploymentRuleId}`, {
      json: dto,
      timeout: 120000, // 2 minutes - deployment rule updates can be slow
    });
  }

  static async GetDeploymentRecalcRun(runId: string) {
    return await this.client.get<GetDeploymentRecalcRunResponseDTO>(`deployment-rules/recalc-runs/${runId}`);
  }

  static async GetManufacturers(dto: GetManufacturersRequestDTO) {
    return await this.client.get<GetManufacturersResponseDTO>('manufacturers', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetQRCodes(dto: GetQRCodesRequestDTO) {
    return await this.client.post<GetQRCodesResponseDTO>('qr-codes', {
      json: dto,
    });
  }

  static async GetUsers(dto: GetUsersRequestDTO) {
    return await this.client.get<GetUsersResponseDTO>('users', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetCurrentSitemateUser() {
    return await this.client.get<GetSitemateUserResponseDTO>('users/current-sitemate-user');
  }

  static async GetUsersStats(dto: GetUsersStatsRequestDTO) {
    return await this.client.get<GetUsersStatsResponseDTO>('users/stats', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async DeleteUsers(dto: DeleteUsersRequestDTO) {
    return await this.client.post<DeleteUsersResponseDTO>('users/bulk-delete', {
      json: dto,
    });
  }

  static async UpdateUserProfile(dto: UpdateUserProfileRequestDTO) {
    return await this.client.patch<UpdateUserProfileResponseDTO>('users/profile', {
      json: dto,
    });
  }

  static async GenerateIssueFilePresignedUploadUrl(dto: GenerateIssueFilePresignedUploadUrlRequestDTO) {
    return await this.client.post<GenerateIssueFilePresignedUploadUrlResponseDTO>('file/generate-issue-file-presigned-upload-url', {
      json: dto,
    });
  }

  static async GenerateDocumentPresignedUploadUrl(dto: GenerateDocumentPresignedUploadUrlRequestDTO) {
    return await this.client.post<GenerateDocumentPresignedUploadUrlResponseDTO>('file/generate-document-presigned-upload-url', {
      json: dto,
    });
  }

  static async GenerateAssetPhotoPresignedUploadUrl(dto: GenerateAssetPhotoPresignedUploadUrlRequestDTO) {
    return await this.client.post<GenerateAssetPhotoPresignedUploadUrlResponseDTO>('file/generate-asset-photo-presigned-upload-url', {
      json: dto,
    });
  }

  static async GeneratePdfAttachmentFormFieldPresignedUploadUrl(dto: GeneratePdfAttachmentFormFieldPresignedUploadUrlRequestDTO) {
    return await this.client.post<GeneratePdfAttachmentFormFieldPresignedUploadUrlResponseDTO>('file/generate-pdf-attachment-form-field-presigned-upload-url', {
      json: dto,
    });
  }

  static async CreatePdfExport(dto: CreatePdfExportRequestDTO, signal?: AbortSignal) {
    return await this.client.post<CreatePdfExportResponseDTO>('exports/pdf', {
      json: dto,
      signal,
    });
  }

  static async GetPdfExportRun(runId: string, signal?: AbortSignal) {
    return await this.client.get<GetPdfExportResponseDTO>(`exports/${runId}`, { signal });
  }

  static async CreateBulkPdfExport(dto: CreateBulkPdfExportRequestDTO, signal?: AbortSignal) {
    return await this.client.post<CreateBulkPdfExportResponseDTO>('exports/pdf-bulk', {
      json: dto,
      signal,
    });
  }

  static async CreateCsvExport(dto: CreateCsvExportRequestDTO, signal?: AbortSignal) {
    return await this.client.post<CreateCsvExportResponseDTO>('exports/csv', {
      json: dto,
      signal,
    });
  }

  static async CreateRegisterPdfExport(dto: CreateRegisterPdfExportRequestDTO, signal?: AbortSignal) {
    return await this.client.post<CreateRegisterPdfExportResponseDTO>('exports/pdf-register', {
      json: dto,
      signal,
    });
  }

  static async GetExportRun(runId: string, signal?: AbortSignal) {
    return await this.client.get<GetExportRunResponseDTO>(`exports/${runId}`, { signal });
  }

  static async UpdateAssetPhoto(assetId: string, dto: UpdateAssetPhotoRequestDTO) {
    return await this.client.put<UpdateAssetPhotoResponseDTO>(`assets/${assetId}/photo`, {
      json: dto,
    });
  }

  static async GetIssueById(issueId: string) {
    return await this.client.get<GetIssueByIdResponseDTO>(`issues/${issueId}`);
  }

  static async GetActions(dto: GetActionsRequestDTO) {
    return await this.client.get<GetActionsResponseDTO>('actions', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetDocumentsByAsset(dto: GetDocumentsByAssetRequestDTO) {
    return await this.client.get<GetDocumentsByAssetResponseDTO>(`documents/asset/${dto.assetId}`, {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateAssetDocument(dto: CreateAssetDocumentRequestDTO) {
    return await this.client.post<CreateAssetDocumentResponseDTO>('documents', {
      json: dto,
    });
  }

  static async UpdateDocument(dto: UpdateDocumentRequestDTO) {
    return await this.client.patch<UpdateDocumentResponseDTO>(`documents/${dto.id}`, {
      json: dto,
    });
  }

  static async BulkUpdateDocumentState(dto: BulkUpdateDocumentStateRequestDTO) {
    return await this.client.patch<undefined>('documents/bulk-update-state', {
      json: dto,
    });
  }

  static async GetDocuments(dto: GetDocumentsRequestDTO) {
    return await this.client.get<GetDocumentsResponseDTO>('documents', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetWorkOrders(dto: GetWorkOrdersRequestDTO) {
    return await this.client.get<GetWorkOrdersResponseDTO>('work-orders', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetUnits(dto: GetUnitsRequestDTO) {
    return await this.client.get<GetUnitsResponseDTO>('units', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async UpsertUnits(dto: UpsertUnitsRequestDTO) {
    return await this.client.put<UpsertUnitsResponseDTO>('units', {
      json: dto,
    });
  }

  static async GetUnitReadings(dto: GetUnitReadingsRequestDTO) {
    return await this.client.get<GetUnitReadingsResponseDTO>('unit-readings', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateUnitReading(dto: CreateUnitReadingRequestDTO) {
    return await this.client.post<CreateUnitReadingResponseDTO>('unit-readings', {
      json: dto,
    });
  }

  static async GetUpcomingChecksSummary() {
    return await this.client.get<GetUpcomingChecksSummaryResponseDTO>('schedules/upcoming-checks-summary');
  }

  static async GetCurrentWebUser() {
    return await this.client.get<GetCurrentWebUserResponseDTO>('auth/current-web-user');
  }

  static async RecordWorkspaceVisit() {
    return await this.client.post<void>('auth/workspace-visit');
  }

  static async GetAddress(dto: GetAddressRequestDTO) {
    return await this.client.get<GetAddressResponseDTO>('addresses', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async SearchAddresses(dto: SearchAddressesRequestDTO) {
    return await this.client.get<SearchAddressesResponseDTO>('addresses/search', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetIssueNotificationRules() {
    return await this.client.get<GetIssueNotificationRulesResponseDTO>('notifications/issues/rules');
  }

  static async GetNotificationRules({ type }: GetNotificationRulesRequestDTO) {
    return await this.client.get<GetNotificationRulesResponseDTO>(`notifications/rules/${type}`);
  }

  static async GetNotifications() {
    return await this.client.get<GetNotificationsResponseDTO>('notifications');
  }

  static async GetNotifyWorkOrder() {
    return await this.client.get<GetNotifyWorkOrderResponseDTO>('notifications/work-order');
  }

  static async UpdateNotifications(dto: UpdateNotificationsRequestDTO) {
    return await this.client.put<UpdateNotificationsResponseDTO>('notifications', {
      json: dto,
    });
  }

  static async UpdateNotificationRules({ type, rules }: UpdateNotificationRulesRequestDTO & { rules: UpdateNotificationRuleItemDTO[] }) {
    return await this.client.put<UpdateNotificationRulesResponseDTO>(`notifications/rules/${type}`, {
      json: rules,
    });
  }

  static async UpdateNotifyInspection(dto: UpdateNotifyInspectionRequestDTO) {
    return await this.client.put<UpdateNotifyInspectionResponseDTO>('notifications/inspection', {
      json: dto,
    });
  }

  static async UpdateNotifyWorkOrder(dto: UpdateNotifyWorkOrderRequestDTO) {
    return await this.client.put<UpdateNotifyWorkOrderResponseDTO>('notifications/work-order', {
      json: dto,
    });
  }

  static async UpsertIssueNotificationRule(dto: UpsertIssueNotificationRuleRequestDTO) {
    return await this.client.put<UpsertIssueNotificationRuleResponseDTO>('notifications/issues/rules', {
      json: dto,
    });
  }

  static async DeleteIssueNotificationRule({ ruleId }: DeleteIssueNotificationRuleRequestDTO) {
    return await this.client.delete<undefined>(`notifications/issues/rules/${ruleId}`);
  }

  // Schedule Notification Rules
  static async GetScheduleNotificationRules(dto: GetScheduleNotificationRulesRequestDTO) {
    return await this.client.get<GetScheduleNotificationRulesResponseDTO>('schedule-notification-rules', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async GetScheduleNotificationRuleById(id: string) {
    return await this.client.get<GetScheduleNotificationRuleByIdResponseDTO>(`schedule-notification-rules/${id}`);
  }

  static async CreateScheduleNotificationRule(dto: CreateScheduleNotificationRuleRequestDTO) {
    return await this.client.post<CreateScheduleNotificationRuleResponseDTO>('schedule-notification-rules', {
      json: dto,
    });
  }

  static async UpdateScheduleNotificationRule(scheduleNotificationRuleId: string, dto: UpdateScheduleNotificationRuleRequestDTO) {
    return await this.client.patch<UpdateScheduleNotificationRuleResponseDTO>(`schedule-notification-rules/${scheduleNotificationRuleId}`, {
      json: dto,
    });
  }

  static async DeleteScheduleNotificationRule({ scheduleNotificationRuleId }: DeleteScheduleNotificationRuleRequestDTO) {
    return await this.client.delete<undefined>(`schedule-notification-rules/${scheduleNotificationRuleId}`);
  }

  static async UpdateAssetMaintenance(dto: UpdateAssetMaintenanceRequestDTO) {
    return await this.client.put<UpdateAssetMaintenanceResponseDTO>(`assets/${dto.assetId}/maintenance`, {
      json: dto,
    });
  }

  static async ReinviteUser({ userId }: ReinviteUserRequestDTO) {
    return await this.client.put<undefined>(`users/${userId}/invite`);
  }

  static async AddUsers(dto: AddUsersRequestDTO) {
    return await this.client.post('users', {
      json: dto,
    });
  }

  static async UpdateUserRole(dto: UpdateUserRoleRequestDTO) {
    return await this.client.patch(`users/${dto.userId}/role`, {
      json: { role: dto.role },
    });
  }

  static async UpdateWorkOrder(dto: UpdateWorkOrderRequestDTO) {
    return await this.client.put<UpdateWorkOrderResponseDTO>(`work-orders/${dto.workOrderId}`, {
      json: dto,
    });
  }

  static async CreateWorkOrder(dto: CreateWorkOrderRequestDTO) {
    return await this.client.post<CreateWorkOrderResponseDTO>('work-orders', {
      json: dto,
    });
  }

  static async BulkUpdateWorkOrderState(dto: BulkUpdateStateWorkOrdersRequestDTO) {
    return await this.client.patch<undefined>('work-orders/bulk-update-state', {
      json: dto,
    });
  }

  static async BulkUpdateWorkOrderStatus(dto: BulkUpdateStatusWorkOrdersRequestDTO) {
    return await this.client.put<undefined>('work-orders/bulk-update-status', {
      json: dto,
    });
  }

  static async BulkUpdateWorkOrderTags(dto: BulkUpdateTagsWorkOrdersRequestDTO) {
    return await this.client.put<undefined>('work-orders/bulk-update-tags', {
      json: dto,
    });
  }

  static async GetWorkOrderById(dto: GetWorkOrderByIdRequestDTO) {
    return await this.client.get<GetWorkOrderByIdResponseDTO>(`work-orders/${dto.workOrderId}`);
  }

  static async GetDashboardFormSubmissions() {
    return await this.client.get<GetDashboardFormSubmissionsResponseDTO>('dashboard/forms/submissions');
  }

  static async GetDashboardInspectionTrend() {
    return await this.client.get<GetDashboardInspectionTrendResponseDTO>('dashboard/inspections/trend');
  }

  static async GetDashboardIssuesSummary() {
    return await this.client.get<GetDashboardIssuesSummaryResponseDTO>('dashboard/issues/summary');
  }

  static async GetDashboardInspectionsToday() {
    return await this.client.get<GetDashboardInspectionsTodayResponseDTO>('dashboard/inspections/today');
  }

  static async GetDashboardRecentIssues() {
    return await this.client.get<GetDashboardRecentIssuesResponseDTO>('dashboard/issues/recent');
  }

  static async GetDashboardIssuesByAsset() {
    return await this.client.get<GetDashboardIssuesByAssetResponseDTO>('dashboard/issues/asset');
  }

  static async GetDashboardOnboarding() {
    return await this.client.get<GetDashboardOnboardingResponseDTO>('dashboard/onboarding');
  }

  static async GetAssetLocations(dto: GetAssetLocationsRequestDTO) {
    return await this.client.get<GetAssetLocationsResponseDTO>('asset-locations', {
      searchParams: this.serializeParams(dto),
    });
  }

  static async CreateAssetLocation(dto: CreateAssetLocationRequestDTO) {
    return await this.client.post<CreateAssetLocationResponseDTO>('asset-locations', {
      json: dto,
    });
  }

  private static serializeParams<T>(params: T): string {
    return qs.stringify(params);
  }
}
